/**
 * @module tournament
 * @description 錦標賽核心引擎共用型別定義
 */
/**
 * Convert raw timerState.level (which counts ALL rows including breaks)
 * to the display level (non-break levels only) that users see on TV
 * and use when configuring deadlines (lateRegLevels, rebuyDeadline, addonDeadline).
 */
export function getDisplayLevel(levels, levelNo) {
    let count = 0;
    for (const l of levels) {
        if (l.levelNo > levelNo)
            break;
        if (!l.isBreak)
            count++;
    }
    return count || levelNo;
}
//# sourceMappingURL=tournament.js.map